import { loginValidation } from "@/utils/valitation/auth";
import { signIn, getSession } from "next-auth/react";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { Form, Formik } from "formik";
import { useContext, useState } from "react";

import Input from "../../Input";
import Loading from "@/components/global/Loading";
import { ModalContext } from "@/pages/_app";
import InputIcon from "../../InputIcon";
import toast from "react-hot-toast";
import { notifyMe, notifyMeOnDrop } from "@/services/global";
import AWSPersonalizeCtx from "@/context/aws-personalize/aws-personalize-context";
import { event_user_login } from "@/utils/gtm";

const LoginEmail = ({ t, language }) => {
  const [show, setShow] = useState(false);
  const [checked, setChecked] = useState(false);
  const handshake = getCookie("handshake");
  const Context = useContext(ModalContext);
  const { firstActionAfterLoginHandler } = useContext(AWSPersonalizeCtx);

  const handleLogin = async (
    { username, password },
    { setSubmitting, setFieldError }
  ) => {
    const res = await signIn("credentials", {
      username,
      password,
      handshake,
      type: "email",
      callbackUrl: "/",
      redirect: false,
    });
    if (!res.ok && res.status !== 200) {
      setFieldError(
        "password",
        language === "en"
          ? "User Name of password is wrong, please try again"
          : "خطأ فى إسم الستخدم او كلمة المرور"
      );
    } else {
      firstActionAfterLoginHandler();
      const session = await getSession();
      const currEntity_id = getCookie("currEntity_id");
      const subscription = getCookie("subscription");
      const currSku = getCookie("currSku");

      if (session?.mage) {
        event_user_login(session?.user)
        if (currEntity_id) {
          const res = await notifyMe(
            handshake,
            currEntity_id,
            session?.user?.id
          ); // , sku, userId
          !res?.data?.data?.[0]?.error &&
            toast.success(
              language === "en"
                ? "You logged in successfully"
                : "تم تسجيل الدخول بنجاح"
            );
          deleteCookie("currEntity_id");
        }

        if (subscription) {
          const res = await notifyMeOnDrop(
            handshake,
            currSku,
            session?.user?.email
          ); // , sku, userId
          !res?.data?.data?.[0]?.error &&
            toast.success(
              t("You will be reminded when the product is available.")
            );
          deleteCookie("subscription");
          deleteCookie("currSku");
        }

        setCookie("mage", session?.mage, { maxAge: 60 * 60 * 24 * 10 });
        Context?.dispatch({ type: "auth" });
      }
      // reset cart and checkout global state
      // merge guest cart if exist
    }
    setSubmitting(false);
  };
  return (
    <Formik
      onSubmit={handleLogin}
      initialValues={{ username: "", password: "" }}
      validationSchema={loginValidation(t)}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="mb-3">
            <Input
              name="username"
              id="email"
              type="text"
              placeholder={t("Email")}
              inputClassName="border p-1.5 max-sm:text-sm max-sm:placeholder:text-sm w-full rounded-sm outline-none"
              t={t}
            />
          </div>
          <div className="mb-1.5 relative">
            <InputIcon
              name="password"
              id="password"
              placeholder={t("Password")}
              inputClassName="border p-1.5 max-sm:text-sm max-sm:placeholder:text-sm w-full rounded-sm outline-none"
              t={t}
              show={show}
              setShow={setShow}
              language={language}
            />
          </div>
          <div className="flex items-center justify-between my-3 max-sm:text-sm">
            <div
              className="flex items-center gap-2"
              onClick={() => setChecked(!checked)}
            >
              <div
                className={`size-4 ${
                  !checked ? "border" : "bg-secondary-900"
                } rounded-sm flex items-center justify-center`}
              ></div>
              <span className="cursor-pointer text-zinc-500">
                {t("Remember Me")}
              </span>
            </div>
            <div
              onClick={() => {
                Context?.dispatch({ type: "auth" });
                Context?.dispatch({ type: "forgotEmail" });
              }}
              className="font-bold underline cursor-pointer"
            >
              {t("Forgot Password")}
            </div>
          </div>
          <button
            className="bg-primary text-white rounded-md font-semibold disabled:cursor-not-allowed max-sm:text-sm p-1.5 w-full"
            type="submit"
          >
            {isSubmitting ? <Loading /> : t("Login")}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default LoginEmail;
